<app-table-no-entries
  *ngIf="onlyLoader === false && listData.empty"
  [dataCy]="'table-empty-state'"
  [title]="title"
  [description]="description"
></app-table-no-entries>
<div *ngIf="listData.loading" class="empty-state" [style.height.px]="height" [dataCy]="'table-loading-state'">
  <app-dot-loader *ngIf="listData.loading"></app-dot-loader>
  <p>{{ 'a-search-for-results-is-in-progress' | translate }}</p>
</div>
